function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.5
}, React.createElement("path", {
  d: "M1.2246 13.3249C1.2404 13.7023 1.55091 14.0001 1.92853 14.0001H8.50593C8.88355 14.0001 9.19406 13.7023 9.20986 13.3249L9.67958 3.40918H0.754883L1.2246 13.3249ZM6.70511 5.87208C6.70511 5.71408 6.83323 5.58594 6.99129 5.58594H7.44901C7.60698 5.58594 7.73519 5.71405 7.73519 5.87208V11.5372C7.73519 11.6952 7.60708 11.8233 7.44901 11.8233H6.99129C6.83329 11.8233 6.70511 11.6953 6.70511 11.5372V5.87208ZM4.70222 5.87208C4.70222 5.71408 4.83034 5.58594 4.98837 5.58594H5.44609C5.60405 5.58594 5.73223 5.71405 5.73223 5.87208V11.5372C5.73223 11.6952 5.60416 11.8233 5.44609 11.8233H4.98837C4.83037 11.8233 4.70222 11.6953 4.70222 11.5372V5.87208ZM2.69927 5.87208C2.69927 5.71408 2.82738 5.58594 2.98541 5.58594H3.44317C3.60116 5.58594 3.72931 5.71405 3.72931 5.87208V11.5372C3.72931 11.6952 3.6012 11.8233 3.44317 11.8233H2.98541C2.82741 11.8233 2.69927 11.6953 2.69927 11.5372V5.87208Z",
  fill: "#96A2AA"
}), React.createElement("path", {
  d: "M9.99237 0.72121H6.958V0.147546C6.958 0.0660786 6.89195 0 6.81045 0H3.62404C3.54258 0 3.47653 0.0660786 3.47653 0.147546V0.721176H0.442124C0.197927 0.721176 0 0.919137 0 1.16333V2.55232H10.4345V1.16337C10.4345 0.919172 10.2366 0.72121 9.99237 0.72121Z",
  fill: "#96A2AA"
}));

var SvgDelete = function SvgDelete(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDelete, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete.d49239ba.svg";
export { ForwardRef as ReactComponent };